<template>
  <div class="controls-column-wrapper">
    <current-controls :grayscale="grayscale" :toggleScale="toggleScale">
    </current-controls>
  </div>
</template>

<script>
import CurrentControls from './CurrentControls';

export default {
  name: 'controls-column',
  props: ['grayscale', 'toggleScale'],
  components: {
    'current-controls': CurrentControls,
  },
};
</script>

<style lang="less">
  .controls-column-wrapper {
    box-sizing: border-box;
    min-height: 200px;
    flex: 0 0 240px;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// ControlsColumn.vue?8dc07d18